// extracted by mini-css-extract-plugin
module.exports = {"progress":"VideoProgress_progress__2ubvP"};